<template>
  <van-popup
    v-model="show"
    closeable
    round
    position="bottom"
    :style="currentType === '其他' ? { height: '380px' } : { height: '330px' }"
  >
    <div class="box-main">
      <div class="box-top">物品信息</div>
      <div class="flex box-type bbm">
        <div
          v-for="(item, index) in typeList"
          :key="index"
          @click="select(item)"
          :class="item === currentType ? 'selected' : ''"
        >
          {{ item }}
        </div>
        <div class="otherBox" v-show="currentType === '其他'">
          <input
            type="text"
            v-model.trim="other"
            maxlength="10"
            placeholder="请输入物品名称"
            class="otherType"
          />
          <span class="valueLength">{{ other.length + '/10' }}</span>
        </div>
      </div>
      <div class="box-item bbm">
        <span>付款方式</span>
        <span class="item-right">寄付</span>
      </div>
      <div class="box-item bbm">
        <span>增值服务</span>
        <span class="item-right">不保价</span>
      </div>
    </div>
    <div class="footer flex" @click="handleComfirm">
      <div class="placeOrder flex">确定</div>
    </div>
  </van-popup>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      typeList: [
        '文件',
        '数码产品',
        '日用品',
        '服饰',
        '农产品',
        '工业品',
        '其他'
      ],
      currentType: '文件',
      other: ''
    }
  },
  methods: {
    handleShow() {
      this.show = true
    },
    select(item) {
      this.currentType = item
      // console.log(this.currentType)
    },
    handleComfirm() {
      if (this.currentType !== '其他') {
        this.$emit('getMsg', this.currentType)
      } else {
        if (this.other !== '') {
          let regRule = new RegExp(
            "[`\\\\~!@#$^&*()+\\-=|{}':;\"',\\[\\]/\\s/.<>/?~！@%_#￥……&*·（）——|{}【】‘；：”“'。，、？]"
          )
          if (regRule.test(this.other)) {
            this.$toast.fail('请勿输入特殊字符')
            return
          }
          this.$emit('getMsg', this.other)
        } else {
          this.$toast.fail('物品信息不能为空')
          return
        }
      }
      this.show = false
    }
  }
}
</script>
<style lang="scss" scoped>
.box-main {
  padding: 15px;
  .box-type {
    width: 100%;
    margin-top: 15px;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 14px;
    div {
      display: flex;
      justify-content: center;
      width: 25%;
      border: 1px solid #ccc;
      border-radius: 3px;
      margin-bottom: 0.5em;
      padding: 0.4em;
    }
    .selected {
      border-color: #e4b3b9;
      background-color: #f2dcdf;
      color: #a30014;
    }
    .otherBox {
      position: relative;
      border: none;
      padding: 0;
      width: 100%;
      // flex: 1;
      .valueLength {
        position: absolute;
        top: 0.4em;
        right: 0.5em;
      }
    }
    .otherType {
      flex: 1;
      border: 1px solid #e4b3b9;
      border-radius: 3px;
      padding: 0.4em;
    }
  }
  .box-item {
    display: flex;
    padding: 10px 0;
    font-size: 15px;
    .item-right {
      display: flex;
      flex: 1;
      justify-content: flex-end;
    }
  }
}
</style>
